export default "__VITE_ASSET__36pIKldx__";